<template>
<div class="mt-50">
    <div class="container">   
        <div class="columns is-multiline">   
            <div class="column is-full">
                <b-field class="image-uploader has-text-centered">
                    <b-upload v-model="file" @input="onFileSelect"
                    multiple
                    accept="image/png,image/jpeg"
                    drag-drop>
                <div class="content has-text-centered">
                <div v-if="menuData.mainImage">
                    <figure class="center-avatar" :style="{ backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + menuData.mainImage + '?alt=media)' }">
                    </figure>
                </div>
                <div v-else>
                    <span>
                        <b-icon
                            icon="upload"
                            size="is-large">
                        </b-icon>
                    </span>
                    <p>Drop your files here or click to upload</p>
                </div>
                            </div>
                    </b-upload>
                </b-field>
                <div class="tags">
                    <span
                        class="tag is-primary" v-if="file">
                        {{file[0].name}}
                        <button class="delete is-small"
                            type="button"
                            @click="deleteDropFile">
                        </button>
                    </span>
                </div>
                    <b-input v-model="menuData.name" size="is-size-3" placeholder="Title" class="meal-title-input"></b-input>   
                    <b-input 
                    maxlength="300" 
                    v-model="menuData.subtitle" 
                    type="textarea"
                    placeholder="Subtitle (make it short!)" 
                    class="meal-subtitle-input"></b-input> 
            </div>  
        </div> 
        <div class="columns is-multiline">
            <div v-for="(menuSegment, index) in menuData.menu" class="column is-one-third" :key="menuSegment.id">
                    <figure class="is-size-5 has-text-left">                        
                        <div>
                        
                        {{menuSegment.dishType}}
                        <div class="is-pulled-right">
                        <a v-if="index != 0">
                            <b-icon pack="fas" icon="arrow-left" @click.native="moveUp(index)"></b-icon>
                        </a>
                        <a v-if="index != (menuData.menu.length - 1)">
                            <b-icon pack="fas" icon="arrow-right" @click.native="moveDown(index)"></b-icon>
                        </a>
                        </div>
                        </div>
                        <div>                        
                        </div>

                    </figure>
                    <div class="media-content">
                    <div class="content" v-for="(recipe, recipe_index) in menuSegment.recipes" :key="recipe.id">
                        <div class="is-pulled-right">
                            <a v-if="recipe_index != 0">
                                <b-icon pack="fas" icon="arrow-up" @click.native="moveRecipeUp({dishType_index:index, recipe_index:recipe_index})"></b-icon>
                            </a>
                            <a v-if="recipe_index != (menuSegment.recipes.length - 1)">
                                <b-icon pack="fas" icon="arrow-down" @click.native="moveRecipeDown({dishType_index:index, recipe_index:recipe_index})"></b-icon>
                            </a>
                        </div>
                        <div class="is-title-5">                        
                            <strong>{{recipe.name}}</strong>                            
                        </div>   
                                             
                        <p>
                        {{recipe.subtitle}}                            
                            <a class="is-pulled-right">
                                <b-icon pack="fas" icon="trash" @click.native="removeFrommenu({dishType_index:index, recipe_index:recipe_index})">    
                                </b-icon>
                            </a>
                        </p>
                    <!--
                    <b-collapse :open="false" position="is-bottom" aria-id="contentIdForA11y1">
                        <a slot="trigger" slot-scope="props" aria-controls="contentIdForA11y1">
                            {{ !props.open ? 'See More' : 'Hide' }}
                        </a>
                        <p>
                            {{recipe}}
                        </p>
                    </b-collapse>
                    -->
                    <hr> 
                    </div>
                    </div>                    
                </div>
                
                                
                
        </div> 
        <div class="columns">
            <div class="column">    
                <div class="buttons">    
                    <span class="button is-success" @click="savemenu">Save changes</span>    
                </div>    
            </div> 
        </div>   
    </div>
</div>
</template>
<script>
import firebase from '@/firebase';
import db from '@/db';
var uuidv4 = require('uuid/v4');

export default {
    data() {
        return {
            id: this.$route.params.id,
            isOpen: 0,
            recipes: [],
            recipeIds: [],
            user_id: null,
            filterText: null,
            newmenuRef: Object,
            menuData: {
                name: null,
                subtitle: null,
                cookTime: {},
                prepTime: {},
                servings: null,
                recipeIndex: Number,
                mainImage: null
            },
            menu: [],
            backgroundUrl: null,
            slug: null,
            userData: Object,
            file: null
        }
    },

    async mounted() {
      await this.fetchData();
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                this.user_id = user.uid;
                this.newmenuRef = db.collection('menus').doc();
                    db.collection('users').doc(firebase.auth().currentUser.uid)
                        .get().then(docSnapshot => {
                            if (!docSnapshot.exists) return;
                            this.userData = docSnapshot.data();
                        });
                
            } else {
                // User not logged in or has just logged out.
            }
        });
    },
    methods: {
        savemenu() {
            let slug = this.sanitizeTitle(this.menuData.name);
            // let uploadedImages = this.$refs.mainImage.getAcceptedFiles();
            const updated_at = new Date();
            db.collection("menus")
              .doc(this.id)
              .set({
                name: this.menuData.name,
                kitchen_name:this.userData.kitchen_name,
                slug: slug,
                subtitle: this.menuData.subtitle,
                mainImage: this.menuData.mainImage,
                menu: this.menuData.menu,
                updated_at:updated_at
              },{merge: true})
              .then(() => {
                this.success();
              });
        },
        removeFrommenu({dishType_index, recipe_index}) {
            this.menuData.menu[dishType_index].recipes.splice(recipe_index, 1);
            if(this.menuData.menu[dishType_index].recipes.length == 0) {
                this.menuData.menu.splice(dishType_index, 1);
            }           
        },
        fetchData() {
          db.collection("menus")
            .doc(this.id)
            .get()
            .then(docSnapshot => {
              if (!docSnapshot.exists) {
                return;
              } 
              if(docSnapshot.data().user_id == firebase.auth().currentUser.uid) {
                this.menuData = docSnapshot.data();
                this.backgroundUrl = this.menuData.mainImage;
              }
              else {
                this.$router.replace('/kitchen/'+firebase.auth().currentUser.uid);
              }
                    

            });
        },
        sanitizeTitle: function(title) {
            var slug = "";
            // Change to lower case
            var titleLower = title.toLowerCase();
            // Letter "e"
            slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
            // Letter "a"
            slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
            // Letter "o"
            slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
            // Letter "u"
            slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
            // Letter "d"
            slug = slug.replace(/đ/gi, 'd');
            // Trim the last whitespace
            slug = slug.replace(/\s*$/g, '');
            // Change whitespace to "-"
            slug = slug.replace(/\s+/g, '-');            
            return slug;
        },
        errorUpload(file, message) {
            console.log(message)
            this.$refs.mainImage.removeFile(file);
        },
        success() {
          this.$buefy.toast.open({
            message: "Recipe saved!",
            position: 'is-bottom',
            type: "is-success"
          });
        },
        deleteDropFile() {
            var imageName = this.menuData.mainImage;
        var imageToRemove = firebase.storage().ref(imageName);
        imageToRemove.delete().then(function() {
                // File deleted successfully
                console.log(imageName + " File deleted successfully");
                
            }).catch(function(error) {
                console.log(error)
            });
            this.file = null;
            this.menuData.mainImage = null;        
      },
      onFileSelect(){
      const file = this.file[0];
      const self = this;
      if (typeof FileReader === 'function') {
        var reader = new FileReader();
        var imageName = uuidv4();
        reader.onloadend = function (evt) {
          var blob = new Blob([evt.target.result], { type: "image/jpeg" });
          firebase.storage().ref(imageName).put(blob)
          .then((snapshot) => {
              return snapshot.ref.getDownloadURL(); // Will return a promise with the download link
          })
          .then((downloadURL) => {
              console.log(`Successfully uploaded file and got download link - ${downloadURL}`);
              return self.setCurrentImage(imageName);
          })
        }
        reader.onerror = function (e) {
            console.log("Failed file read: " + e.toString());
        };
        reader.readAsArrayBuffer(file);
      } else {
        alert('Sorry, FileReader API not supported')
      }
        
      },
      setCurrentImage(downloadURL) {
              // console.log(downloadURL);
            this.menuData.mainImage =  downloadURL;
      },
      moveUp(index){
        let cutOut = this.menuData.menu.splice(index, 1) [0]; // cut the element at index 'from'
        this.menuData.menu.splice((index-1), 0, cutOut); 
      },
      moveDown(index){
        let cutOut = this.menuData.menu.splice(index, 1) [0]; // cut the element at index 'from'
        this.menuData.menu.splice((index+1), 0, cutOut); 
      },
      moveRecipeUp({dishType_index, recipe_index}){
        let cutOut = this.menuData.menu[dishType_index].recipes.splice(recipe_index, 1) [0]; // cut the element at index 'from'
        this.menuData.menu[dishType_index].recipes.splice((recipe_index-1), 0, cutOut); 
      },
      moveRecipeDown({dishType_index, recipe_index}){
            let cutOut = this.menuData.menu[dishType_index].recipes.splice(recipe_index, 1) [0]; // cut the element at index 'from'
        this.menuData.menu[dishType_index].recipes.splice((recipe_index+1), 0, cutOut); 
      },
    }
};
</script>